import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { GlobalService } from '@core/services/global/global.service';
import { filter, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css'],
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  breadcrumbs: Array<{ label: string; url: string }> = [];
  breadcrumbMessage = '';

  private readonly destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private globalService: GlobalService,
  ) {}

  ngOnInit(): void {
    // Subscribe to global breadcrumb message
    this.globalService.breadcrumb$
      .pipe(takeUntil(this.destroy$))
      .subscribe((message) => {
        this.breadcrumbMessage = message;
      });

    // Subscribe to router navigation events
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
        takeUntil(this.destroy$),
      )
      .subscribe((event: NavigationEnd) => {
        this.breadcrumbs = this.createBreadcrumbs(
          event.urlAfterRedirects || event.url,
        );
      });
  }

  /**
   * Builds breadcrumb labels from the URL unless on login page.
   */
  private createBreadcrumbs(
    url: string,
  ): Array<{ label: string; url: string }> {
    if (url.startsWith('/login')) {
      return [];
    }

    const pathSegments = url.split('?')[0].slice(1).split('/');
    const breadcrumbs = pathSegments.map((segment, index) => ({
      label: segment.replace(/-/g, ' '),
      url: '/' + pathSegments.slice(0, index + 1).join('/'),
    }));

    return breadcrumbs;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
